// extracted by mini-css-extract-plugin
export default {"root":"GFYlHm1P9cJYSIQzFEJk","tag":"DxqXn2XBTOyzxV1pnUsK"};